var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("h3", [_vm._v("图表介绍")]),
      _vm._v(" "),
      _c("p", [_vm._v("Funnel Chart，漏斗图。")]),
      _vm._v(" "),
      _c("h3", [_vm._v("attrs")]),
      _vm._v(" "),
      _c("p", [
        _vm._v("attrs 包含若干布局属性，将这些属性放入 Object 对象传入组件")
      ]),
      _vm._v(" "),
      _c("table", [
        _c("thead", [
          _c("tr", [
            _c("th", [_vm._v("属性名")]),
            _vm._v(" "),
            _c("th", [_vm._v("类型")]),
            _vm._v(" "),
            _c("th", [_vm._v("默认值")]),
            _vm._v(" "),
            _c("th", [_vm._v("描述")])
          ])
        ]),
        _vm._v(" "),
        _c("tbody", [
          _c("tr", [
            _c("td", [_vm._v("align")]),
            _vm._v(" "),
            _c("td", [_vm._v("String")]),
            _vm._v(" "),
            _c("td", [_vm._v("'center'")]),
            _vm._v(" "),
            _c("td", [_vm._v("组件位置，可选值 left、center、right")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("pyramid")]),
            _vm._v(" "),
            _c("td", [_vm._v("Boolean")]),
            _vm._v(" "),
            _c("td", [_vm._v("false")]),
            _vm._v(" "),
            _c("td", [_vm._v("漏斗形状是否为金字塔底")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("clientRect")]),
            _vm._v(" "),
            _c("td", [_vm._v("Object")]),
            _vm._v(" "),
            _c("td", [_vm._v("{top,right,bottom,left,width,height}")]),
            _vm._v(" "),
            _c("td", [_vm._v("设置了 width,heigh,优先与 bottom,right")])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("h3", [_vm._v("style 属性")]),
      _vm._v(" "),
      _c("p", [_vm._v("组件中可以自定义属性的元素如下表：")]),
      _vm._v(" "),
      _c("table", [
        _c("thead", [
          _c("tr", [
            _c("th", [_vm._v("名称")]),
            _vm._v(" "),
            _c("th", [_vm._v("基本类型")]),
            _vm._v(" "),
            _c("th", [_vm._v("描述")])
          ])
        ]),
        _vm._v(" "),
        _c("tbody", [
          _c("tr", [
            _c("td", [_vm._v("polygon")]),
            _vm._v(" "),
            _c("td", [_vm._v("面")]),
            _vm._v(" "),
            _c("td", [_vm._v("漏斗区块样式")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("polygon:hover")]),
            _vm._v(" "),
            _c("td", [_vm._v("面")]),
            _vm._v(" "),
            _c("td", [_vm._v("鼠标 hover 时漏斗区块样式")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("guideText")]),
            _vm._v(" "),
            _c("td", [_vm._v("文本")]),
            _vm._v(" "),
            _c("td", [_vm._v("组件上的文本样式")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("guideline")]),
            _vm._v(" "),
            _c("td", [_vm._v("线")]),
            _vm._v(" "),
            _c("td", [_vm._v("指示线样式")])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("使用方法可在"),
        _c("a", { attrs: { href: "#/demo/funnel/others" } }, [
          _vm._v("样式调整 demo")
        ]),
        _vm._v("中查看，用法如下：")
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "在 data 中定义元素样式，可以是 Boolean、 obj 属性或者函数，例如："
        )
      ]),
      _vm._v(" "),
      _c("pre", { pre: true }, [
        _c(
          "code",
          { pre: true, attrs: { "v-pre": "", class: "language-javascript" } },
          [
            _c("span", { pre: true, attrs: { class: "hljs-comment" } }, [
              _vm._v("// 新建funnel组件")
            ]),
            _vm._v("\n"),
            _c("span", { pre: true, attrs: { class: "hljs-keyword" } }, [
              _vm._v("const")
            ]),
            _vm._v(" funnel = "),
            _c("span", { pre: true, attrs: { class: "hljs-keyword" } }, [
              _vm._v("new")
            ]),
            _vm._v(" Funnel()\n\n"),
            _c("span", { pre: true, attrs: { class: "hljs-comment" } }, [
              _vm._v("//设置true或false来隐藏组件元素")
            ]),
            _vm._v("\n"),
            _c("span", { pre: true, attrs: { class: "hljs-comment" } }, [
              _vm._v("//隐藏漏斗上的文字")
            ]),
            _vm._v("\nfunnel.style("),
            _c("span", { pre: true, attrs: { class: "hljs-string" } }, [
              _vm._v('"text"')
            ]),
            _vm._v(", "),
            _c("span", { pre: true, attrs: { class: "hljs-literal" } }, [
              _vm._v("false")
            ]),
            _vm._v(")\n\n"),
            _c("span", { pre: true, attrs: { class: "hljs-comment" } }, [
              _vm._v("//参考spritejs的attr属性来设置样式")
            ]),
            _vm._v("\n"),
            _c("span", { pre: true, attrs: { class: "hljs-comment" } }, [
              _vm._v("//设置指示线样式")
            ]),
            _vm._v("\nfunnel.style("),
            _c("span", { pre: true, attrs: { class: "hljs-string" } }, [
              _vm._v('"guideline"')
            ]),
            _vm._v(", { "),
            _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
              _vm._v("length")
            ]),
            _vm._v(": "),
            _c("span", { pre: true, attrs: { class: "hljs-number" } }, [
              _vm._v("20")
            ]),
            _vm._v(", "),
            _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
              _vm._v("color")
            ]),
            _vm._v(": "),
            _c("span", { pre: true, attrs: { class: "hljs-string" } }, [
              _vm._v('"#000"')
            ]),
            _vm._v(", "),
            _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
              _vm._v("lineDash")
            ]),
            _vm._v(": ["),
            _c("span", { pre: true, attrs: { class: "hljs-number" } }, [
              _vm._v("2")
            ]),
            _vm._v(", "),
            _c("span", { pre: true, attrs: { class: "hljs-number" } }, [
              _vm._v("2")
            ]),
            _vm._v("] })\n\n"),
            _c("span", { pre: true, attrs: { class: "hljs-comment" } }, [
              _vm._v(
                "//参数polygon为绘制的polygon属性，dataOrigin为原始数据项，index是绘制索引"
              )
            ]),
            _vm._v("\nfunnel.style("),
            _c("span", { pre: true, attrs: { class: "hljs-string" } }, [
              _vm._v('"polygon"')
            ]),
            _vm._v(", (polygon, dataOrigin, index) => {\n  "),
            _c("span", { pre: true, attrs: { class: "hljs-comment" } }, [
              _vm._v("// 根据索引来给每个元素赋色")
            ]),
            _vm._v("\n  "),
            _c("span", { pre: true, attrs: { class: "hljs-keyword" } }, [
              _vm._v("if")
            ]),
            _vm._v(" (index % "),
            _c("span", { pre: true, attrs: { class: "hljs-number" } }, [
              _vm._v("2")
            ]),
            _vm._v(" === "),
            _c("span", { pre: true, attrs: { class: "hljs-number" } }, [
              _vm._v("0")
            ]),
            _vm._v(") {\n    "),
            _c("span", { pre: true, attrs: { class: "hljs-keyword" } }, [
              _vm._v("return")
            ]),
            _vm._v(" { "),
            _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
              _vm._v("fillColor")
            ]),
            _vm._v(": "),
            _c("span", { pre: true, attrs: { class: "hljs-string" } }, [
              _vm._v('"#59CB74"')
            ]),
            _vm._v(" }\n  }\n  "),
            _c("span", { pre: true, attrs: { class: "hljs-keyword" } }, [
              _vm._v("return")
            ]),
            _vm._v(" { "),
            _c("span", { pre: true, attrs: { class: "hljs-attr" } }, [
              _vm._v("fillColor")
            ]),
            _vm._v(": "),
            _c("span", { pre: true, attrs: { class: "hljs-string" } }, [
              _vm._v('"#FBD54A"')
            ]),
            _vm._v(" }\n})\n")
          ]
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }